import React from "react";
import { Image } from "react-native";

const RsvpEventImage = ({ url }: { url?: string | null }) => {
  if (!url) return null;
  return (
    <Image
      source={{ uri: url }}
      resizeMode="cover"
      style={{
        aspectRatio: 16 / 9,
        borderRadius: 8,
        marginBottom: 24,
      }}
    />
  );
};

export default RsvpEventImage;
